import { ColourTheme } from "@components/atoms/ColourTheme"
import { Appear } from "@components/motion/Appear"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Impact Figures",
  tags: ["#page"],
}

export default defineBlock("section/impact-figures", (props) => {
  return (
    <Appear className="impact-figures w-full my-9 md:px-6" slide>
      <ColourTheme
        theme={props.colourTheme || props.defaultColourTheme}
        className={cn(
          "py-7 rounded-md [&_.section-bridge]:mt-0 [&_.section-bridge]:mb-6 [&_.section-bridge]:justify-center [&_.section-bridge]:text-center [&_.section-bridge_*]:!text-current [&_.section-bridge-description]:hidden [&_.features-stack-inner]:my-6",
        )}
      >
        <div className="w-full max-w-blogPostVideoW block-padding mx-auto">
          <InnerBlocks
            allowedBlocks={["section/section-bridge", "section/impact-figures-inner"]}
            template={[
              ["section/section-bridge", {}],
              ["section/impact-figures-inner", {}],
            ]}
            templateLock="all"
          />
        </div>
      </ColourTheme>
    </Appear>
  )
})
